/**
 * Shared upload step behind every "change your try-on photo" surface.
 * Compresses client-side (compressPhoto.js) before the multipart POST so a
 * raw phone photo doesn't trip API Gateway's ~4-4.5MB 413 ceiling.
 */
import { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import mahi, { errMsg } from '../api';
import compressPhoto from '../compressPhoto';

export default function useProfilePhotoUpload() {
  const [busy, setBusy] = useState(false);

  const upload = useCallback(async (file) => {
    setBusy(true);
    try {
      const compressed = await compressPhoto(file);
      const form = new FormData();
      form.append('file', compressed);
      const { data } = await mahi.post('/profile/photo', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success('Photo updated');
      return data.photo_url;
    } catch (e) {
      toast.error(errMsg(e, 'Could not update your photo'));
      throw e;
    } finally {
      setBusy(false);
    }
  }, []);

  return { upload, busy };
}
